// @flow
import * as actions from './actions';
import * as model from './model';
import reducer from './reducer';

export { actions, model };

export default reducer;
